import type { City, PointComment, VendingPoint } from '../types/domain'

const createdAt = '2026-08-01T10:00:00.000Z'

export const demoCities: City[] = [
  { id: 1, slug: 'milano', name: 'Milano', province: 'MI', region: 'Lombardia', center_lat: 45.4642, center_lng: 9.19, default_zoom: 13, active: true, created_at: createdAt, point_count: 0 },
  { id: 2, slug: 'roma', name: 'Roma', province: 'RM', region: 'Lazio', center_lat: 41.9028, center_lng: 12.4964, default_zoom: 13, active: true, created_at: createdAt, point_count: 0 },
  { id: 3, slug: 'napoli', name: 'Napoli', province: 'NA', region: 'Campania', center_lat: 40.8518, center_lng: 14.2681, default_zoom: 13, active: true, created_at: createdAt, point_count: 0 },
  { id: 4, slug: 'bari', name: 'Bari', province: 'BA', region: 'Puglia', center_lat: 41.1171, center_lng: 16.8719, default_zoom: 14, active: true, created_at: createdAt, point_count: 2 },
]

export const demoPoints: VendingPoint[] = [
  {
    id: '00000000-0000-4000-8000-000000000001', city_id: 4, name: 'Punto test H24 Bari Centro',
    category: 'snack_bevande',
    description: 'Punto temporaneo per la verifica dell’applicazione.', address: 'Corso Vittorio Emanuele II, Bari',
    latitude: 41.126, longitude: 16.869, is_h24: true, cash_supported: true, card_supported: true,
    notes: 'Dato di test: rimuovere prima della pubblicazione di punti reali.',
    water_price_eur: 0.5, coke_zero_price_eur: null,
    beer_price_eur: 1.5, prices_updated_at: createdAt,
    verification_status: 'verified', has_pending_revision: false, active: true, version: 1,
    source_type: 'admin', source_ref: 'test:bari-centro', source_url: null, created_by: null, updated_by: null,
    created_by_name: null, last_modified_by: null, last_modified_by_name: null,
    created_at: createdAt, updated_at: createdAt,
  },
  {
    id: '00000000-0000-4000-8000-000000000002', city_id: 4, name: 'Punto test H24 Madonnella',
    category: 'snack_bevande',
    description: 'Secondo punto temporaneo per i test end-to-end.', address: 'Via Giuseppe Capruzzi, Bari',
    latitude: 41.1112, longitude: 16.8728, is_h24: true, cash_supported: true, card_supported: false,
    notes: null, water_price_eur: null, coke_zero_price_eur: null,
    beer_price_eur: null, prices_updated_at: null,
    verification_status: 'unverified', has_pending_revision: true, active: true, version: 1,
    source_type: 'admin', source_ref: 'test:bari-madonnella', source_url: null, created_by: null, updated_by: null,
    created_by_name: null, last_modified_by: null, last_modified_by_name: null,
    created_at: createdAt, updated_at: createdAt,
  },
]

export const demoComments: PointComment[] = [
  { id: '00000000-0000-4000-8000-000000000101', point_id: demoPoints[0]!.id, user_id: null, display_name: 'Marco B.', body: 'Funziona perfettamente, acqua fredda e pagamento con carta.', status: 'visible', created_at: '2026-08-02T09:30:00.000Z' },
  { id: '00000000-0000-4000-8000-000000000102', point_id: demoPoints[0]!.id, user_id: null, display_name: 'Giulia P.', body: 'Macchina pulita e ben rifornita.', status: 'visible', created_at: '2026-08-04T17:45:00.000Z' },
]
